module.exports = __webpack_public_path__ + "4f5f7f6236dcf57ac03cd2849fba6056.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/03_icon_project_web.gif
// module id = 688
// module chunks = 0